module.exports = __webpack_public_path__ + "img/businessBg.904518e3.jpg";